<script setup>
import { HCol, HDropdown } from '@pixul/hephaestus';
import NavbarItemContent   from '@/components/Navbar/NavbarItemContent.vue';
</script>

<template>
  <NavbarItemContent
    v-if='!item.children'
    v-model:hover-item='localHoverItem'
    :is-mobile='isMobile'
    :item='item'
    :only-icon='onlyIcon'
    :tooltip='tooltip'
    @item-click='onClick(item)'
  />

  <template v-else-if='isMobile'>
    <NavbarItemContent
      v-model:hover-item='localHoverItem'
      is-mobile
      :item='item'
      :open='open'
      @item-click='open = !open'
    />
    <HCol v-if='open'>
      <template v-for='child in item.children'>
        <NavbarItemContent
          v-if='!child.hide'
          :key='child.name'
          v-model:hover-item='localHoverItem'
          is-child
          is-mobile
          :item='child'
          @item-click='onClick(child)'
        />
      </template>
    </HCol>
  </template>

  <HDropdown
    v-else
    position='bottom-left'
    @close='open = false'
  >
    <template #activator='{ activatorClick }'>
      <NavbarItemContent
        v-model:hover-item='localHoverItem'
        :item='item'
        :open='open'
        @item-click='onClick(item, activatorClick)'
      />
    </template>
    <template #default='{ closeDropdown }'>
      <HCol>
        <template v-for='child in item.children'>
          <NavbarItemContent
            v-if='!child.hide'
            :key='child.name'
            v-model:hover-item='localHoverItem'
            :item='child'
            @item-click='onClick(child, closeDropdown)'
          />
        </template>
      </HCol>
    </template>
  </HDropdown>
</template>

<script>
export default {
  name : 'NavbarItem',

  props : {
    item : {
      type    : Object,
      default : () => {}
    },

    hoverItem : {
      type    : String,
      default : null
    },

    isMobile : {
      type    : Boolean,
      default : false
    },

    onlyIcon : {
      type    : Boolean,
      default : false
    },

    tooltip : {
      type    : String,
      default : ''
    }
  },

  emits : ['update:hoverItem', 'clickOnItem'],

  data() {

    return {
      open           : false,
      localHoverItem : null
    };
  },

  watch : {
    '$router.currentRoute.value.name'() {

      if (this.item.children) {

        const currentPath = this.$router.currentRoute.value.name;
        this.open = !!this.item.children.find(child => child.name === currentPath);
      }
    },

    localHoverItem() {

      this.$emit('update:hoverItem', this.localHoverItem);
    }
  },

  created() {

    this.localHoverItem = this.hoverItem;
  },

  methods : {
    onClick(item, callback) {

      this.open = !this.open;

      if (callback) {

        callback();
      }

      if (item.function) {

        item.function();
      }

      if (item.name !== 'question' && item.name !== 'notifications' && item.name !== 'language' && !item.children) {

        this.$router.push(item);
      }

      this.$emit('clickOnItem');
    }
  }
};
</script>

<style scoped>
:deep(.c-info-modal__content) {
    min-width: 100%;
}
</style>
